export const importTemplate = {
  selectOption: {
    id: '0',
    name: '--- Select an option ---',
    description: 'Default empty space'
  },
  defaultDateFormat: 'MM/DD/YYYY',
  dateFormats: ['MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'MM/DD/YY', 'DD/MM/YY', 'YY/MM/DD']
};